import { ProFormColumnsType } from '@ant-design/pro-components';
import { Card } from 'antd';
import { FormattedMessage } from 'react-intl';
import { DeleteIcon } from '@components/common/Icons/DeleteIcon';
import { BaseFormSchemaProps } from '../types';
import { BROKER_DEPOSIT_SOURCE_TYPES, calculateDepositAmount } from './depositSourcesHelpers';

export function ooDepositSourcesFormSchema(props: BaseFormSchemaProps): ProFormColumnsType[] {
  return [
    {
      valueType: 'dependency',
      name: ['purchasePrice', 'financingAmount'],
      columns: ({ purchasePrice, financingAmount }) => [
        {
          title: props.formatMessage({ id: 'btlApplicationForm.FINANCING.deposit.label' }),
          dataIndex: 'depositAmount',
          valueType: { type: 'money', locale: 'en-GB' },
          width: 300,
          fieldProps: {
            precision: 0,
            disabled: true,
            value: calculateDepositAmount(purchasePrice, financingAmount),
          },
        },
      ],
    },
    {
      title: props.formatMessage({ id: 'btlApplicationForm.FINANCING.depositSources.label' }),
      dataIndex: 'depositSources',
      valueType: 'formList',
      fieldProps: {
        copyIconProps: false,
        creatorButtonProps: props.isFormEditable && {
          position: 'bottom',
          creatorButtonText: props.formatMessage({
            id: 'btlApplicationForm.FINANCING.depositSources.add.label',
          }),
        },
        itemRender: ({ listDom }: any, { index, operation }: any) => (
          <Card
            title={`${props.formatMessage({ id: 'btlApplicationForm.FINANCING.depositSources.source.label' })} ${
              index + 1
            }`}
            className={'bg-white/60 border-gray-300 border-dashed w-full'}
            extra={
              operation.remove && props.isFormEditable ? (
                <a onClick={() => operation.remove(index)}>
                  <DeleteIcon />
                </a>
              ) : null
            }
            style={{ marginBottom: 16 }}
          >
            {listDom}
          </Card>
        ),
      },
      columns: [
        {
          dataIndex: 'id',
          valueType: 'text',
          formItemProps: { hidden: true, noStyle: true },
          fieldProps: { hidden: true },
        },
        {
          title: props.formatMessage({ id: 'btlApplicationForm.FINANCING.depositSources.amount.label' }),
          dataIndex: 'amount',
          valueType: { type: 'money', locale: 'en-GB' },
          width: 300,
          fieldProps: {
            precision: 0,
          },
          formItemProps: {
            hasFeedback: true,
            rules: [
              {
                required: true,
                message: props.formatMessage({ id: 'btlApplicationForm.FINANCING.depositSources.amount.error' }),
                min: 1,
                type: 'number',
              },
            ],
          },
        },
        {
          title: props.formatMessage({ id: 'btlApplicationForm.FINANCING.depositSources.type.label' }),
          dataIndex: 'sourceType',
          valueType: 'select',
          fieldProps: {
            showSearch: true,
            allowClear: !props.isDipAcceptedOrLater,
            placeholder: props.formatMessage({ id: 'btlApplicationForm.FINANCING.depositSources.type.placeholder' }),
            options: BROKER_DEPOSIT_SOURCE_TYPES.map((type, index) => ({
              label: <FormattedMessage id={`btlApplicationForm.FINANCING.depositSources.type.${index}.label`} />,
              value: type,
            })),
          },
          formItemProps: {
            hasFeedback: Boolean(props.isDipAcceptedOrLater),
            rules: props.isDipAcceptedOrLater
              ? [
                  {
                    required: true,
                    message: props.formatMessage({ id: 'btlApplicationForm.FINANCING.depositSources.type.error' }),
                  },
                ]
              : [],
          },
        },
        {
          title: props.formatMessage({ id: 'btlApplicationForm.FINANCING.depositSources.description.label' }),
          dataIndex: 'description',
          valueType: 'text',
          fieldProps: {
            allowClear: true,
            placeholder: props.formatMessage({
              id: 'btlApplicationForm.FINANCING.depositSources.description.placeholder',
            }),
          },
        },
      ],
    },
  ];
}
